import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import SnackbarContent from '@mui/material/SnackbarContent';

interface BeforeInstallPromptEvent extends Event {
    prompt: () => void;
    userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
    }>;
}

const InstallPrompt: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (event: Event) => {
            const beforeInstallPromptEvent = event as BeforeInstallPromptEvent;
            beforeInstallPromptEvent.preventDefault();
            setDeferredPrompt(beforeInstallPromptEvent);
            setShowInstallPrompt(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt as EventListener);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt as EventListener);
        };
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('Usuário aceitou a instalação do PWA');
                } else {
                    console.log('Usuário rejeitou a instalação do PWA');
                }
                setDeferredPrompt(null);
                setShowInstallPrompt(false);
            });
        }
    };

    const handleCancelClick = () => {
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
    };

    return (
        showInstallPrompt && (
            <Stack spacing={2} sx={{ position: 'fixed', bottom: 0, maxWidth: 600, margin: 2 }}>
                <SnackbarContent
                    message={'Você pode instalar nosso aplicativo para uma melhor experiência.'}
                    action={
                        <>
                            <Button color="inherit" size="small" onClick={handleInstallClick}>
                                Instalar
                            </Button>
                            <Button color="inherit" size="small" onClick={handleCancelClick}>
                                Fechar
                            </Button>
                        </>
                    }
                />
            </Stack>
        )
    );
};

export default InstallPrompt;
